import Deferred from './deferred'

//
// Smooth scroll-to inspired by:
// http://stackoverflow.com/a/24559613/728480
//
function scrollTo (scrollTo, scrollDuration) {
    const deferred = new Deferred()
    //
    // Set a default for where we're scrolling to
    //
    let scrollToObj
    const type = typeof scrollTo
    if (['string', 'object'].indexOf(type) > -1) {
        scrollToObj = scrollTo
        if (type === 'string') {
            // Assuming this is a selector we can use to find an element
            scrollToObj = document.querySelector(scrollTo)
        }

        if (scrollToObj && typeof scrollToObj.getBoundingClientRect === 'function') {
            scrollTo = window.pageYOffset + scrollToObj.getBoundingClientRect().top
        } else {
            throw new Error(`error: No element found with the selector "${scrollTo}"`)
        }
    } else if (typeof scrollTo !== 'number') {
        // If it's nothing above and not an integer, we assume top of the window
        scrollTo = 0
    }

    //
    // Set a default for the duration
    //
    if (typeof scrollDuration !== 'number' || scrollDuration < 0) {
        scrollDuration = 500
    }

    // Declarations
    let initialTimestamp = window.performance.now()
    let currentTime = 0
    let initialScroll = window.pageYOffset
    let deltaScroll = initialScroll - scrollTo
    let viewportHeight = window.innerHeight
    let bodyHeight = document.body.clientHeight

    // Set scrollDuration indexed on the amount of scroll
    if (deltaScroll <= viewportHeight) {
        // scrollDuration = Math.abs(scrollDuration * Math.sin(Math.abs(deltaScroll) / viewportHeight * Math.PI / 2))
        // scrollDuration = scrollDuration
    } else {
        scrollDuration = Math.abs(scrollDuration + scrollDuration * (Math.abs(deltaScroll) / (bodyHeight - viewportHeight)))
    }

    let finalTimestamp = initialTimestamp + scrollDuration

    function step () {
        let currentTimestamp = window.performance.now()
        if (currentTimestamp < finalTimestamp) {
            currentTime = (currentTimestamp - initialTimestamp) / scrollDuration
            // currentTime = currentTime * (2 - currentTime) // easeOutQuad
            currentTime = (--currentTime) * currentTime * currentTime + 1 // easeOutCubic
            const moveStep = deltaScroll * currentTime
            window.scrollTo(0, scrollTo + (deltaScroll - moveStep))
            window.requestAnimationFrame(step)
        } else {
            window.scrollTo(0, scrollTo)
            setTimeout(() => deferred.resolve(), 125)
        }
        return deferred.promise
    }

    window.requestAnimationFrame(step)
    return deferred.promise
}

//
// Performance.now() polyfill from:
// https://gist.github.com/paulirish/5438650
//
(function () {
    if ('performance' in window === false) {
        window.performance = {}
    }
    Date.now = (Date.now || function () { // thanks IE8
        return new Date().getTime()
    })
    if ('now' in window.performance === false) {
        let nowOffset = Date.now()
        if (window.performance.timing && window.performance.timing.navigationStart) {
            nowOffset = window.performance.timing.navigationStart
        }
        window.performance.now = function now () {
            return Date.now() - nowOffset
        }
    }
})()

export default scrollTo
